import { render, staticRenderFns } from "./NurseDetails.vue?vue&type=template&id=2e5b8f77&scoped=true"
import script from "./NurseDetails.vue?vue&type=script&lang=js"
export * from "./NurseDetails.vue?vue&type=script&lang=js"
import style0 from "./NurseDetails.vue?vue&type=style&index=0&id=2e5b8f77&prod&scoped=true&lang=css"
import style1 from "./NurseDetails.vue?vue&type=style&index=1&id=2e5b8f77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b8f77",
  null
  
)

export default component.exports